import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MruFileItem } from '../mru/mru-file-item.model';

export const enum SidePopupMenuType {
    FormsMove,
    Dismiss
}

interface SidePopupMenuBasicModel<T extends SidePopupMenuType> {
    type: T;
    isShown: boolean;
}

export type SidePopupMenuModel = SidePopupMenuDismissModel | SidePopupMenuFormsMoveModel;

export interface FormsMoveResolveModel {
    moveTargetId: string;
    moveTargetName: string;
}

export interface SidePopupMenuFormsMoveModel extends SidePopupMenuBasicModel<SidePopupMenuType.FormsMove> {
    index: number;
    movingFileItem: MruFileItem;
    resolveMoveModel: (value: FormsMoveResolveModel) => void;
}

export interface SidePopupMenuDismissModel extends SidePopupMenuBasicModel<SidePopupMenuType.Dismiss> {
    isShown: false;
}

@Injectable({
    providedIn: 'root'
})
export class SidePopupMenuService {
    public sidePopupMenuEmitter: BehaviorSubject<SidePopupMenuModel> = new BehaviorSubject<SidePopupMenuModel>(null);
}
